import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import { VISIBILITY_STATUS } from '../../store/api/status'

export default class VisibilityStatusIcon extends React.Component {
    getIcon(status) {
        var icon = 'exclamation-triangle'
        switch (status) {
            case 'hidden':
                icon = 'eye-slash'
                break
            case 'published':
                icon = 'eye'
                break
            default:
                break
        }
        return icon
    }

    getTooltip(status) {
        var tooltip = ''

        switch (status) {
            case VISIBILITY_STATUS.HIDDEN:
                tooltip = 'This idea is not visible to regular users.'
                break
            case VISIBILITY_STATUS.PUBLISHED:
                tooltip = 'This idea is visible to all users.'
                break
            default:
                break
        }
        return tooltip
    }

    onClick = (e) => {
        this.props.onClick && this.props.onClick(e.target.id)
    }

    render() {
        var icon = this.getIcon(this.props.status)

        return (
            <div className="status-balls dropdown">
                <button
                    className="status-button"
                    disabled={this.props.disabled}
                    data-toggle="dropdown"
                    data-toggle-second="tooltip"
                    data-placement="top"
                    title={this.getTooltip(this.props.status)}>
                    <h5 className="text-secondary">
                        <FontAwesomeIcon icon={icon} />
                    </h5>
                </button>

                <div className="dropdown-menu" style={{ width: '220px' }}>
                    <button
                        onClick={this.onClick}
                        id={VISIBILITY_STATUS.HIDDEN}
                        className="dropdown-item"
                        disabled={
                            this.props.status === VISIBILITY_STATUS.HIDDEN
                        }>
                        Hide
                    </button>
                    <button
                        onClick={this.onClick}
                        id={VISIBILITY_STATUS.PUBLISHED}
                        className="dropdown-item"
                        disabled={
                            this.props.status === VISIBILITY_STATUS.PUBLISHED
                        }>
                        Publish
                    </button>
                </div>
            </div>
        )
    }
}
